import { render, staticRenderFns } from "./ProductHighCost.vue?vue&type=template&id=897c17da&scoped=true&"
import script from "./ProductHighCost.vue?vue&type=script&lang=js&"
export * from "./ProductHighCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897c17da",
  null
  
)

export default component.exports